import React, { useState } from 'react';

import useCreatorSuggestion from '../../hooks/use-creator-suggestion/useCreatorSuggestion';
import Creator from '../../components/creator/creator.component';
import { CreatorSkeleton } from '../../components/creator';
import { useNavigate } from 'react-router-dom';
import { ICreator } from '../../types/creator';

const GRID_CLASS =
  'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-[18px] gap-y-6';

const PAGE_SIZE = 8;

const CreatorSuggestionPage: React.FC = () => {
  const {
    creators,
    getCreatorsSuggestion,
    removeCreatorSuggestion,
    getMatchFavCreators,
    matchFavCreators,
  } = useCreatorSuggestion();
  const navigate = useNavigate();
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const [visibleMatchFavCount, setVisibleMatchFavCount] = useState(PAGE_SIZE);

  const renderSkeletons = () =>
    Array(PAGE_SIZE)
      .fill(null)
      .map((_, index) => <CreatorSkeleton key={index} />);

  const renderNotFound = () => (
    <div className="col-span-full text-center py-12">
      <p className="ui-muted text-lg">Không tìm thấy nhà sáng tạo nào</p>
    </div>
  );

  const showMoreButton = (onClick: () => void) => (
    <div className="flex justify-center mt-8">
      <button
        type="button"
        onClick={onClick}
        className="rounded-full bg-[#066bff] hover:bg-[#0559d6] text-white text-lg font-medium pl-5 pr-6 py-4 leading-none transition-colors"
      >
        Xem thêm
      </button>
    </div>
  );

  const renderSection = (
    title: string,
    list: ICreator[] | undefined,
    visible: number,
    onShowMore: () => void,
    onSuccess: () => void,
    withProfileLink: boolean
  ) => (
    <section>
      <h2 className="ui-heading text-2xl md:text-[30px] md:leading-[38px] font-semibold tracking-[-0.03em] mb-6">
        {title}
      </h2>

      {list === undefined ? (
        <div className={GRID_CLASS}>{renderSkeletons()}</div>
      ) : list.length === 0 ? (
        <div className={GRID_CLASS}>{renderNotFound()}</div>
      ) : (
        <>
          <div className={GRID_CLASS}>
            {list.slice(0, visible).map((creator) => (
              <Creator
                key={creator.userId}
                creator={creator}
                onClick={
                  withProfileLink
                    ? () => navigate(`/user/${creator.username}`)
                    : undefined
                }
                onSuccess={onSuccess}
                removeSuggestion={removeCreatorSuggestion}
              />
            ))}
          </div>
          {visible < list.length && showMoreButton(onShowMore)}
        </>
      )}
    </section>
  );

  return (
    <div className="min-h-screen w-full max-w-[1240px] mx-auto px-4 md:px-10 py-6 flex flex-col gap-12">
      {renderSection(
        'Creator nổi bật',
        creators,
        visibleCount,
        () => setVisibleCount((prev) => prev + PAGE_SIZE),
        getCreatorsSuggestion,
        true
      )}

      {renderSection(
        'Creator bạn có thể thích',
        matchFavCreators,
        visibleMatchFavCount,
        () => setVisibleMatchFavCount((prev) => prev + PAGE_SIZE),
        getMatchFavCreators,
        true
      )}
    </div>
  );
};

export default CreatorSuggestionPage;
